var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgIcInfo32Dp = function SvgIcInfo32Dp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    transform: "translate(11 7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.6 16.039l-.276 1.026c-.934.334-4.17 1.738-6.037.244-.556-.444-.834-1.008-.834-1.692 0-1.282.464-2.4 1.297-5.084.147-.506.327-1.165.327-1.687 0-.9-.375-1.14-1.395-1.14-.498 0-1.048.162-1.547.331l.276-1.026C1.523 6.601 2.92 6.1 4.115 6.1c1.793 0 3.112.813 3.112 2.36 0 .445-.085 1.226-.263 1.766l-1.031 3.317c-.213.67-.6 2.148-.002 2.587.59.432 1.982.203 2.669-.091z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.75,
    cy: 2.045,
    rx: 2.25,
    ry: 2.045
  }))));
};

export default "/_next/static/ic_info_32dp-4a49d674706e89608ef315a4770d018asvg";
export { SvgIcInfo32Dp as ReactComponent };